<div class="__terms-privacy">
  <small>
    <mip-translate key="register-form.terms">
      By Login or Register, you agreed to <a href="{{ networkUrl }}/terms-of-service" target="_blank">Terms</a> and
      <a href="{{ networkUrl }}/privacy" target="_blank">Privacy Policy</a>.
    </mip-translate>
  </small>
</div>
